import { Pipe, PipeTransform } from '@angular/core';
import { HaEditIcdModal } from '../models/HaEditIcd.model';

@Pipe({
  name: 'haEditcptpipe'
})
export class HaEditcptpipePipe implements PipeTransform {

  transform(cptData: HaEditIcdModal[], searchTermCpt: string): HaEditIcdModal[] {
    //console.log("search term is"+searchTermCpt);
    //console.log("icddata"+cptData);
    if (!cptData || !searchTermCpt) { return cptData; }
    
    cptData.forEach(element => {
  if(element.description==null ){
    element.description="";
  }
  if(element.category==null ){
    element.category="";
  }
  if(element.helpText==null ){
    element.helpText="";
  }
});
    return cptData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermCpt.toLowerCase().trim()) !== -1 

      ||
      ad.description.toLowerCase().indexOf(searchTermCpt.toLowerCase().trim()) !== -1
      ||
      ad.category.toLowerCase().indexOf(searchTermCpt.toLowerCase().trim()) !== -1
      ||
      ad.helpText.toLowerCase().indexOf(searchTermCpt.toLowerCase().trim()) !== -1

    );
  }
}
